import React from 'react';
import { Box, Skeleton } from 'housecall-ui';

export const PaymentSkeleton = () => {
  return (
    <Box py={2}>
      <Box py={1}>
        <Skeleton variant="rect" height="24px" width="100%" />
      </Box>
      {Array.from({ length: 4 }).map((_, index) => (
        <Box key={index} py={1}>
          <Skeleton variant="rect" height="56px" width="100%" />
        </Box>
      ))}
    </Box>
  );
};
